export default function MoreVerticalIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.33301 9.99967C8.33301 9.0792 9.0792 8.33301 9.99967 8.33301C10.9201 8.33301 11.6663 9.0792 11.6663 9.99967C11.6663 10.9201 10.9201 11.6663 9.99967 11.6663C9.0792 11.6663 8.33301 10.9201 8.33301 9.99967Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.33301 4.16667C8.33301 3.24619 9.0792 2.5 9.99967 2.5C10.9201 2.5 11.6663 3.24619 11.6663 4.16667C11.6663 5.08714 10.9201 5.83333 9.99967 5.83333C9.0792 5.83333 8.33301 5.08714 8.33301 4.16667Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.33301 15.8337C8.33301 14.9132 9.0792 14.167 9.99967 14.167C10.9201 14.167 11.6663 14.9132 11.6663 15.8337C11.6663 16.7541 10.9201 17.5003 9.99967 17.5003C9.0792 17.5003 8.33301 16.7541 8.33301 15.8337Z'
        />
      </svg>
    </span>
  );
}
